import { createApp } from 'vue'
import './style.css'
// 导入 OpenLayers 的样式文件
// OpenLayers 10.x 可能需要使用完整路径
import 'ol/ol.css'
import App from './App.vue'
import router from './router'

createApp(App).use(router).mount('#app')
